import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import isLength from 'validator/lib/isLength';
import { isNotPhoneUS, isPhoneInvalid } from 'utils/phoneHelpers';

// Global parameters
export const LENGTH_DOT_NUMBER = 7;

export type TCareerValues = {
  firstName: string;
  lastName: string;
  companyName: string;
  DOTNumber: string;
  phone: string;
  email: string;
  message: string;
  chose: string;
};

type CareerValues = Partial<TCareerValues>;

export const careerValidation = ({
  email = '',
  firstName = '',
  lastName = '',
  companyName = '',
  phone = '',
  DOTNumber = '',
}: CareerValues): CareerValues => {
  const errors: CareerValues = {};

  // Email
  if (!isEmail(email)) errors.email = 'Invalid Email address';
  if (isEmpty(email)) errors.email = 'Required field';

  // First Name
  if (isEmpty(firstName)) errors.firstName = 'Required field';

  // Last Name
  if (isEmpty(lastName)) errors.lastName = 'Required field';

  // Company Name
  if (isEmpty(companyName)) errors.companyName = 'Required field';

  // Phone
  if (isNotPhoneUS(phone)) errors.phone = 'Not a US phone number';
  if (isPhoneInvalid(phone)) errors.phone = 'Invalid phone number';
  if (isEmpty(phone)) errors.phone = 'Required field';

  // DOTNumber
  if (!isLength(DOTNumber, { min: LENGTH_DOT_NUMBER, max: LENGTH_DOT_NUMBER }))
    errors.DOTNumber = `Must have ${LENGTH_DOT_NUMBER} digits`;
  if (isEmpty(DOTNumber)) errors.DOTNumber = 'Required field';

  return errors;
};
